import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../utils/AxiosService'
import Input from '../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function PayoutPriceField({ action }) {
  const readOnly = useReadOnly()
  const { campaign, primaryScenarioId } = useContext(CampaignContext)
  const { id } = useParams()
  const [currentTimeout, setCurrentTimeout] = useState(null)

  const changeInfluencerPayoutPrice = influencer_payout_price => {
    if (currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitInfluencerPayoutPrice(influencer_payout_price), 1000))
  }

  const handleFormSubmit = values => {
    if (currentTimeout) clearTimeout(currentTimeout)
    const price = typeof values?.influencer_payout_price === 'object'
      ? values.influencer_payout_price?.influencer_payout_price
      : values?.influencer_payout_price
    submitInfluencerPayoutPrice(price)
  }

  const submitInfluencerPayoutPrice = influencer_payout_price => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { influencer_payout_price }})
    .then((updatedAction) => {
      toastSuccess('Payout Price updated')
      action.influencer_payout_price = updatedAction.influencer_payout_price
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <div>
      <Formik
        initialValues={{ influencer_payout_price: action.influencer_payout_price }}
        onSubmit={handleFormSubmit}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form className="w-full">
            <div className="relative">
              <Input
                disabled={readOnly}
                addon={campaign.currency_symbol}
                addonPosition="start"
                error={touched.influencer_payout_price && errors.influencer_payout_price}
                name="influencer_payout_price"
                noLabelPadding
                onChange={(e) => {
                  changeInfluencerPayoutPrice(e.target.value)
                  handleChange(e)
                }}
                onBlur={handleBlur}
                value={values.influencer_payout_price}
                overrideClassName="h-7"
                topMargin="mt-0"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
})

